

<div class="container" style="padding-left: 24px">

    <h5 class="size15 mb-2">Details de l'entreprise</h5>
    <div class="mb-3 items">
        <div class="">
            <div class="logo-card" (click)="logoInput.click()">
                <ng-container *ngIf="!logoPreview">


                    <div class="logo-upload-text">
                        <div style="color: #134AD3" class="mb-2">
                            <i [size]="25" data-feather="image"></i>
                        </div>

                        <strong>Ajouter votre logo</strong><br/>
                        <p class="size13" style="color: #2F2B3DB2">La limite de lâ€™image est de 3
                            Megabytes</p>

                        <button style="color: #134AD3" class="unstyled-btn" >

                            <i [size]="24" data-feather="download"></i>

                        </button>
                    </div>
                </ng-container>
                <ng-container *ngIf="logoPreview">
                    <img [src]="logoPreview || file_url" alt="Logo choisi" class="logo-img" />


                </ng-container>
                <input
                        type="file"
                        #logoInput
                        class="custom-file-input"
                        accept="image/*"
                        (change)="onFileSelected($event)"

                />

            </div>
            <div class="invalid-feedback d-block" *ngIf="dataError.logo">
                {{ dataError.logo }}
            </div>
        </div>

        <div class="flex-grow-1">
            <div class="mb-2">
                <label class="size13">Nom de l'entreprise <span class="text-danger">*</span></label>

                <input type="text" class="form-control"
                       placeholder="Nom de l'entreprise"
                       [(ngModel)]="data.nom_entreprise" name="nom_entreprise"
                       [ngClass]="{ 'is-invalid': dataError.nom_entreprise }"
                       (input)="clearFieldError('nom_entreprise')"
                />
                <div *ngIf="dataError.nom_entreprise" class="invalid-feedback d-block">
                    {{ dataError.nom_entreprise }}
                </div>
            </div>
            <div class="mb-2">
                <label class="size13">Matricule fiscale </label>
                <input type="text" class="form-control" placeholder="Matricule fiscale" [(ngModel)]="data.matricule_fiscale"  name="matricule_fiscale"/>
            </div>

            <label class="size13">Site web</label>
            <input
                    type="text"
                    class="form-control"
                    placeholder="Entrez l'URL de votre site web"
                    [(ngModel)]="data.site_web"
                    name="site_web"
            />
        </div>

    </div>
    <h5 class="size15 mb-2">Adresse de lâ€™entreprise</h5>
    <ng-container *ngFor="let adr of data.adresses; let i = index">
        <div class="row mb-2">
            <div class="col-lg-6">
                <label class="size13">Pays</label>
                <input type="text" class="form-control" placeholder="Entrez votre pays"
                       [(ngModel)]="data.adresses[i].pays" name="pays{{i}}"/>
            </div>
            <div class="col-lg-6">
                <label class="size13">RÃ©gion <span class="text-danger">*</span> </label>
                <input type="text" class="form-control" placeholder="Entrez votre rÃ©gion"
                       [(ngModel)]="data.adresses[i].region" name="region{{i}}"
                       [ngClass]="{ 'is-invalid': dataError.adresses[i].region }"
                       (input)="clearAddressFieldError(i, 'region')"
                />
                <div *ngIf="dataError.adresses[i].region" class="invalid-feedback d-block">
                    {{ dataError.adresses[i].region }}
                </div>
            </div>
        </div>

        <div class="row mb-2">
            <div class="col-lg-6">
                <label class="size13">Code postal <span class="text-danger">*</span> </label>
                <input type="text" class="form-control" placeholder="Entrez votre code postal"
                       [(ngModel)]="data.adresses[i].code_postal" name="code_postal{{i}}"
                       [ngClass]="{ 'is-invalid': dataError.adresses[i].code_postal }"
                       (input)="clearAddressFieldError(i, 'code_postal')">
                <div *ngIf="dataError.adresses[i].code_postal" class="invalid-feedback d-block">
                    {{ dataError.adresses[i].code_postal }}
                </div>
            </div>
            <div class="col-lg-6">
                <label class="size13">Adresse <span class="text-danger">*</span> </label>
                <div class="d-flex">
                    <input type="text" class="form-control" placeholder="Entrez votre adresse"
                           [(ngModel)]="data.adresses[i].adresse" name="adresse{{i}}"
                           [ngClass]="{ 'is-invalid': dataError.adresses[i].adresse }"
                           (input)="clearAddressFieldError(i, 'adresse')">


                </div>
                <div *ngIf="dataError.adresses[i].adresse" class="invalid-feedback d-block">
                    {{ dataError.adresses[i].adresse }}
                </div>
            </div>

        </div>
    </ng-container>




    <h5 class="size15 mb-2">CoordonnÃ©es</h5>
    <div class="row">
        <div class="col-lg-4">
            <label class="size13">PrÃ©nom</label>
            <input type="text" class="form-control" placeholder="Entrez votre prÃ©nom" [(ngModel)]="data.prenom" name="prenom">
        </div>
        <div class="col-lg-4">
            <label class="size13">Nom</label>
            <input type="text" class="form-control" placeholder="Entrez votre nom" [(ngModel)]="data.nom" name="nom">
        </div>
        <div class="col-lg-4">
            <label class="size13">Adresse e-mail</label>
            <input type="text" class="form-control" placeholder="Entrez votre adresse email" [(ngModel)]="data.email" name="email">
        </div>
        <div class="col-lg-12"><br></div>
        <ng-container *ngFor="let tel of data.telephones; let i = index">

            <div class="col-lg-4">
                <label class="size13">Type de tÃ©lÃ©phone <span class="text-danger">*</span></label>
                <select class="form-control"
                        [(ngModel)]="tel.type"
                        [name]="'type' + i"
                        [ngClass]="{ 'is-invalid': dataError.tel }"
                        (change)="clearFieldError('tel')">

                    <option value="whatsapp">Whatsapp</option>
                    <option value="mobile">Mobile</option>
                    <option value="fixe">Fixe</option>
                </select>
                <div *ngIf="dataError.tel" class="invalid-feedback d-block">
                    {{ dataError.tel }}
                </div>
            </div>

            <div class="col-lg-8 mb-1">
                <label class="size13">NumÃ©ro de tÃ©lÃ©phone <span class="text-danger">*</span></label>
                <div class="d-flex">
                    <input type="number" class="form-control" placeholder="44610978"
                           [(ngModel)]="tel.numero" [name]="'numero' + i"
                           [ngClass]="{ 'is-invalid': dataError.telephones[i] }"
                           (input)="clearPhoneError(i)"
                           min="10000000"
                           max="99999999"
                           pattern="[0-9]{8}"
                           oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 8)">
                    <button *ngIf="data.telephones.length>1" type="button" class="ml-1 btn btn-icon btn-danger waves-effect waves-float waves-light float-right"
                            (click)="deleteTel(i)">
                        <i [size]="17" data-feather="minus"></i>
                    </button>
                </div>
                <div *ngIf="dataError.telephones[i]" class="invalid-feedback d-block">
                    {{ dataError.telephones[i] }}
                </div>
            </div>

        </ng-container>
        <div class="col-lg-12" style="margin-top:30px">
            <a style="color:#134AD3" (click)="addTel()"><b>Ajouter un numÃ©ro de tÃ©lÃ©phone</b></a>
        </div>
        <div class="col-lg-12" *ngIf="data.telephones.length > 2" style="height:50px"></div>


    </div>
    <div class="d-flex justify-content-end mt-3 mb-2">
        <button  (click)="submit()" class="btn btn-primary">
            Enregistrer
        </button>
    </div>
</div>
